import React, { FunctionComponent, useContext } from "react";
import { ListActionButtonProps } from "sprint-common-web";

import { AddToMergeListButton } from "../../../../../common/components/AddToMergeListButton";
import { canEpisodesMerge } from "../canEpisodeMerge";
import { SeasonEpisodeListingContext } from "../context/SeasonEpisodeListingContext";
import { EpisodeListingItem } from "../EpisodeListingItem";

export const AddEpisodeToMergeListButton: FunctionComponent<ListActionButtonProps> = (props: ListActionButtonProps) => {
    const { episodesToMerge, listingItems, addEpisodeToMergeList } = useContext(SeasonEpisodeListingContext);

    const mergeButtonDisabled = (): boolean => {
        const item = listingItems.find((listingItem: EpisodeListingItem) => listingItem.id === props.itemId);
        if (episodesToMerge.length > 1) return true;

        return !canEpisodesMerge(episodesToMerge[0], item);
    };

    const handleClick = () => {
        const item = listingItems.find((listingItem: EpisodeListingItem) => listingItem.id === props.itemId);
        addEpisodeToMergeList(item);
    };

    return <AddToMergeListButton disabled={props.disabled || mergeButtonDisabled()} onClick={handleClick} />;
};
